export default {
    name: "AccountManagerInformation",
    setup(){
        
    }
}